import { useEffect } from "react";

/** Admin/artboard dev server ports (see apps/admin/vite.config.ts, apps/artboard/vite.config.ts) */
const DEV_PORTS = { admin: 4001, artboard: 6173 } as const;

/**
 * Full-page redirect to another app path (admin, artboard).
 * Used when the client app is wrongly served for /admin or /artboard (e.g. dev on wrong port).
 * In dev, redirects to the correct app's port; in prod, same-origin path so nginx can serve the right app.
 *
 * IMPORTANT: Preserves the full URL path so /artboard/builder stays as /artboard/builder,
 * not just /artboard/. This ensures the target app's router matches the correct route.
 */
export function AppRedirect({ to, label = "page" }: { to: string; label?: string }) {
  useEffect(() => {
    const isDev = typeof window !== "undefined" && window.location.hostname === "localhost";
    // Preserve the actual path the user/iframe requested instead of always going to the base
    const currentPath = window.location.pathname;
    let href = currentPath || to;

    if (isDev) {
      if (currentPath.startsWith("/admin"))
        href = `http://localhost:${DEV_PORTS.admin}${currentPath}`;
      else if (currentPath.startsWith("/artboard"))
        href = `http://localhost:${DEV_PORTS.artboard}${currentPath}`;
    }

    window.location.href = href;
  }, [to]);

  const currentPath = typeof window !== "undefined" ? window.location.pathname : to;

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="border-primary mx-auto size-12 animate-spin rounded-full border-2 border-t-transparent" />
        <p className="mt-4 text-gray-600">Redirecting to {label}…</p>
        <p className="mt-2 text-sm text-gray-500">
          <a href={currentPath} className="text-primary underline">
            Click here if not redirected
          </a>
        </p>
      </div>
    </div>
  );
}
